import { render, staticRenderFns } from "./New.vue?vue&type=template&id=300bae68"
import script from "./New.vue?vue&type=script&lang=ts"
export * from "./New.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports